(function ($) {
    document.addEventListener('DOMContentLoaded', function () {
        documentMouseUp('.myCustomSelect-wrapper');
    });

    function documentMouseUp(elem) {
        $(document).on('mouseup', function (e) {
            let container = $(elem);

            if (container.has(e.target).length !== 0) {
                if (!container.hasClass('open')) {
                    container.addClass('open');
                } else {
                    container.removeClass('open');
                }
            } else {
                container.removeClass('open');
            }
        });
    }
})(jQuery);
